import microuniversoApi from "app/api/microuniversoApi";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { Breadcrumb2Container } from "app/components/breadcrumb2/Breadcrumb2Container";
import { Separador } from "app/components/separador/Separador";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import {
  FiltroPesquisaFornecedor,
  Fornecedor,
  PesquisaFornecedor
} from "./PesquisaFornecedor";


export type PesquisaFornecedorContainerProps = {
  onVoltar: () => void,
  passos: Dict<string, () => void>
  regiaoRenderizada: string
  onSelecionadoFornecedor: (codigoFornecedor: string, nomeFornecedor: string) => void
}

export const PesquisaFornecedorContainer = (props: PesquisaFornecedorContainerProps) => {
  const [fornecedores, setFornecedores] = useState<PagedMessageResponse<Fornecedor>>(null);
  const [flitroFornecedor, setFiltroFornecedor] = useState<FiltroPesquisaFornecedor>({
    CnpjCpf: "",
    InscricaoEstadual: "",
    Nome: "",
    NumeroPagina: 1,
    TamanhoPagina: 20,
  });

  const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

  const pesquisar = async (flitros: FiltroPesquisaFornecedor) => {
    try {
      globalMU.blockUI();
      const filtrosSanitizados: FiltroPesquisaFornecedor = {
        ...flitros,
        CnpjCpf: flitros.CnpjCpf ?? "",
        InscricaoEstadual: flitros.InscricaoEstadual ?? "",
        Nome: flitros.Nome ?? "",
      };
      setFiltroFornecedor(filtrosSanitizados);
      const fornecedores = await microuniversoApi.Fonecedor.pesquisar(filtrosSanitizados);
      setFornecedores(fornecedores);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const pesquisaPaginada = async (numeroIndexPagina: number) => {
    try {
      const filtrosAlterado = {
        ...flitroFornecedor,
        NumeroPagina: numeroIndexPagina,
      };
      globalMU.blockUI();
      setFiltroFornecedor(flitroFornecedor);
      const fornecedores = await microuniversoApi.Fonecedor.pesquisar(
        filtrosAlterado
      );
      setFornecedores(fornecedores);
    } catch (e) {
      tratamentoErroPadrao(e);
    } finally {
      globalMU.unblockUI();
    }
  };

  const onPassoSelecionado = (passo: string) => {
    passosInterno.current.get(passo)()
  }

  const onVoltar = () => {
    props.onVoltar()
  }

  return (
    <>

      <Breadcrumb2Container
        passos={passosInterno.current.set("Pesquisar Fornecedores", () => { }).keysToList()}
        exibirBotaoLimpar={false}
        exibirBotaoVoltar={true}
        id="PesquisaFornecedorContainer"
        onPassoSelecionado={onPassoSelecionado}
        onBotaoVoltarClicado={onVoltar}
      />

      <Separador />

      <PesquisaFornecedor
        fornecedores={fornecedores}
        filtroPesquisaFornecedor={flitroFornecedor}
        onPesquisar={pesquisar}
        onFornecedorSelecionado={(nomeFornecedor, codigoFornecedor) => {
          props.onSelecionadoFornecedor(codigoFornecedor, nomeFornecedor)
        }}
        onAlterarListaSelecionada={(filtro) => pesquisaPaginada(filtro)}
      />
    </>
  );
};
